import React from 'react'
import { compose } from 'recompose'
import { connect } from '@ln613/state'
import { withMount } from '@ln613/compose'
import ImageSlider from './ImageSlider'
import { withMobile } from '@ln613/ui/semantic'
import actions from 'utils/actions'
import { homeSelector } from 'utils/selectors'

// The first two entries are YouTube videos; their ids are NOT hardcoded here —
// they come from lookup.videos (stored in the DB, managed on the admin Pictures
// page). 'video' is just a marker for those slots.
export const cards = [
  'video',
  'video',
  'News',
  'Court',
  'Club',
  'Sales',
  'Products',
  'League',
  'Students',
  'VIP',
]

export const isVideoCard = c => c === 'video'

// 0-based index of a video card among the video cards (card 0 -> 0, card 1 -> 1)
const videoOrdinal = i => cards.slice(0, i + 1).filter(isVideoCard).length - 1

const c1 = (m, counts, videos) => (
  <div className={`fw pb16 ${m ? '' : 'ph8'}`}>
    {cards.map((c, i) =>
      m ? (
        c2(c, i, m, counts, videos)
      ) : (
        <div key={i} className="f w20 p8">
          {c2(c, i, m, counts, videos)}
        </div>
      )
    )}
  </div>
)

const D1 = ({ isMobile, children }) => (
  <div className={`${isMobile ? '' : 'card'} fv w100`}>{children}</div>
)

const c2 = (c, i, m, counts, videos) => {
  if (isVideoCard(c)) {
    const id = (videos || [])[videoOrdinal(i)]
    return <D1 isMobile={m}>{id ? yt(`https://www.youtube.com/embed/${id}`, m) : null}</D1>
  }
  const c3 = (
    <ImageSlider
      n={counts['slider-' + i] || 0}
      f={i}
      name={c}
      t={6}
      filter="c_fill,w_600,h_450"
    />
  )
  const c4 = <div className="p8 fs18 tac">{c}</div>

  return m ? (
    <D1 isMobile={m}>
      {c4}
      {c3}
    </D1>
  ) : (
    <D1 isMobile={m}>
      {c3}
      {c4}
    </D1>
  )
}

const yt = (s, m) => (
  <iframe
    title="home"
    src={s}
    frameBorder="0"
    style={{ overflow: 'hidden', height: m ? '300px' : '100%', width: '100%' }}
    height={m ? '300px' : '100%'}
    width="100%"
  ></iframe>
)

const Home = ({ isMobile, lookup }) => {
  const counts = (lookup && lookup.cdCounts) || {}
  const videos = (lookup && lookup.videos) || []
  const news = (lookup && lookup.news) || ''
  return (
  <div>
    {/* News section — editable on the admin News page (stored in DB config) */}
    <div className="p16" dangerouslySetInnerHTML={{ __html: news }} />

    <div className="p8"></div>
    <ImageSlider n={counts['slider'] || 0} t={6} fitHeight={!isMobile} />

    <div className="p16">
      <h2>Introduction</h2>
      <div>
        Vancouver Table Tennis Club (VTTC) is one of the best table tennis club
        in the Greater Vancouver area. The Club offers high quality
        tournament-level tables in a comfortable, well-lit playing environment.
      </div>
    </div>

    {c1(isMobile, counts, videos)}
  </div>
  )
}

export default compose(
  connect(homeSelector, actions),
  withMount(p => p.getLookup()),
  withMobile
)(Home)

//2021 MVTTL U-2000 will start on Mar. 26th. The doubles game will be replaced by a single game in order to keep social distance.
